// Impressão da etiqueta patrimonial 10x5cm na térmica: no rolo, cada etiqueta
// tem 10 cm de largura por 5 cm ao longo do papel.
// Usada pelo cadastro e pela edição — manter geometria num lugar só.

const escapeHtml = (text) => String(text ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
));

const imprimirEtiqueta = ({ local, setor, ramal }) => {
    const antigo = document.getElementById('etiqueta-print-iframe');
    if (antigo) antigo.remove();
    const iframe = document.createElement('iframe');
    iframe.id = 'etiqueta-print-iframe';
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`<!DOCTYPE html><html><head><style>
      /* A página é a etiqueta: 100x50, texto reto. A 50x100 com o texto girado
         saía de lado na térmica e invadia a etiqueta seguinte.
         Tamanho forçado: sem "size" explícito a etiqueta sai encolhida (~50%)
         na térmica. Com ele o navegador ignora o Retrato/Paisagem do diálogo
         (o Chrome esconde a opção, o Edge mostra e não aplica). */
      @page { size: 100mm 50mm; margin: 0; }
      html, body { margin: 0; padding: 0; }
      .etiqueta { width: 100mm; height: 50mm;
        box-sizing: border-box; padding: 4mm 6mm;
        display: flex; flex-direction: column; justify-content: center;
        font-family: Arial, sans-serif; }
      p { margin: 1.5mm 0; font-size: 16pt; font-weight: bold; white-space: nowrap; overflow: hidden; }
    </style></head><body><div class="etiqueta">
      <p>Local: ${escapeHtml(local)}</p>
      <p>Setor: ${escapeHtml(setor)}</p>
      <p>Ramal: ${escapeHtml(ramal)}</p>
    </div></body></html>`);
    doc.close();
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
};

export default imprimirEtiqueta;
